<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">账户</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">实名认证</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="th-panel-title">实名认证</div>
      </div>
      <div class="panel-body z-margin-bottom-25-precent">
        <div class="auth-container clearfix">
          <div class="auth-content clearfix">
            <div class="auth-content-left"></div>
            <div class="auth-content-right">
              <h4>恭喜您已通过阿贝云实名认证！</h4>
              <p>
                <span>认证类型：</span>
                阿贝云个人认证
              </p>
              <p>
                <span>真实姓名：</span>
                **肖
              </p>
              <p>
                <span>证件号码：</span>
                130*********3X
              </p>
              <p>
                <span>认证时间：</span>
                2018-10-08 17::58:56
              </p>
              <p>如果需要修改认证信息请联系客服人员</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
  </div>
</template>
<script>
  import bmdService from 'business/bmdService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import {mapGetters,mapActions} from 'vuex'
  export default {
    data () {
      return {
        dialogLoading:false,
      }
    },
    components:{
      XdialogLoading,
    },
    props:{
      hide:Boolean
    },
    mounted() {

    },
    methods:{
      ...mapActions(['SETTHREE_MENU']),
      async submit() {
        this.$router.push('/fuwu5')
        /*let data = 'cmd=bmd_add'+
          '&domainname='+ this.bmdForm.domain +
          '&ip='+ this.bmdForm.ip
        this.dialogLoading = true
        let {vueData, state} = await bmdService.transformToVue('bmdInfo','POST',data)
        if(vueData.response == 200 ) {
          this.dialogLoading = false
          let self = this
          this.$dialog({type:'success', info: vueData.msg, click () {
              self.SETTHREE_MENU(1)
              self.$router.push('/fuwu5')
          }})
        }else {
          this.dialogLoading = false
          this.$dialog({type:'error', info: vueData.msg, click () {}})
        }*/
      }
    }
  }
</script>
<style scoped>
  .page {
    margin-top: 45px;
    width: 100%;
  }
  .hideleft { margin-left: 80px; }
  .auth-container {
    border: 1px solid #eee;
  }
  .auth-content {
    margin: 40px 0 90px 255px;
  }
  .auth-content-left {
    float: left;
    margin-top: 48px;
    width: 141px;
    height: 117px;
    background: url(../../assets/imgs/auth-success.png) no-repeat;
  }
  .auth-content-right {
    float: left;
    margin-left: 105px;
  }
  .auth-content-right h4 {
    font-size: 26px;
    color: #333;
    margin-bottom: 20px;
  }
  .auth-content-right p {
    line-height: 32px;
  }
  .auth-content-right span {
    color: #ababab;
  }
</style>




// WEBPACK FOOTER //
// src/pages/user/successAuth.vue